export default "__VITE_ASSET__94cba4dc__"